var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "protocol_search_container"
  }, [_c('div', {
    staticClass: "protocol_view_container"
  }, [_c('div', {
    staticClass: "view_top_btn"
  }, [_c('a', {
    staticClass: "back_btn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('goToList');
      }
    }
  }, [_vm._v("목록으로")])]), _c('div', {
    staticClass: "view_head"
  }, [_c('div', {
    staticClass: "protocol_search_item"
  }, [_c('div', {
    staticClass: "top_info"
  }, [_c('div', {
    staticClass: "txt_cont"
  }, [_c('div', {
    staticClass: "tit_label"
  }, [_vm.uniqueNumber ? _c('span', {
    staticClass: "label_color color_02"
  }, [_vm._v(_vm._s(_vm.protocolType)), _c('em', [_vm._v("|")]), _vm._v(_vm._s(_vm.uniqueNumber))]) : _c('span', {
    staticClass: "label_color color_02"
  }, [_vm._v(_vm._s(_vm.protocolType))]), _c('span', {
    staticClass: "label_gray"
  }, [_vm._v(_vm._s(`${_vm.fieldName.split(">").join(" / ")}`))])]), _c('div', {
    staticClass: "tit_link",
    domProps: {
      "innerHTML": _vm._s(_vm.name)
    }
  }), _c('ul', {
    staticClass: "protocol_label_list"
  }, [_vm._l(_vm.material ? _vm.material.split(';') : [], function (name) {
    return name.trim() !== '' ? _c('li', {
      staticClass: "label_01 material"
    }, [_c('span', [_vm._v(_vm._s(name))])]) : _vm._e();
  }), _vm._l(_vm.measurement ? _vm.measurement.split(';') : [], function (name) {
    return name.trim() !== '' ? _c('li', {
      staticClass: "label_02 measurement"
    }, [_c('span', [_vm._v(_vm._s(name))])]) : _vm._e();
  }), _vm._l(_vm.analysis ? _vm.analysis.split(';') : [], function (name) {
    return name.trim() !== '' ? _c('li', {
      staticClass: "label_04 analysis"
    }, [_c('span', [_vm._v(_vm._s(name))])]) : _vm._e();
  }), _vm._l(_vm.equipment ? _vm.equipment.split(';') : [], function (name) {
    return name.trim() !== '' ? _c('li', {
      staticClass: "label_03 equipment"
    }, [_c('span', [_vm._v(_vm._s(name))])]) : _vm._e();
  })], 2)])]), _c('div', {
    staticClass: "bottom_info"
  }, [_c('ul', {
    staticClass: "user_set"
  }, [_c('li', [_vm._v(_vm._s(_vm.lastEditDate) + " ")]), _c('li', [_vm._v("책임작성자 : " + _vm._s(_vm.userData.name))]), _vm.collaborators.length > 1 ? _c('li', [_vm._v("공동작성자 : "), _vm._l(_vm.collaborators, function (collaborator, collaboratorKey) {
    return collaboratorKey > 0 ? _c('span', {
      key: collaboratorKey
    }, [_vm._v(_vm._s(`${collaboratorKey != 1 ? " ," + collaborator.name : collaborator.name}`))]) : _vm._e();
  })], 2) : _vm._e()]), _c('ul', {
    staticClass: "btn_set"
  }, [_c('li', [_c('a', {
    staticClass: "writer_more_btn",
    class: _vm.writerListActive ? 'on' : null,
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function ($event) {
        _vm.writerListActive = !_vm.writerListActive;
      }
    }
  }, [_vm._v("작성자 더보기")])]), _vm.processType == 'NORMAL' ? _c('li', {
    staticClass: "process"
  }, [_c('a', {
    staticClass: "process_chart_btn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('goToProcessDetail');
      }
    }
  }, [_vm._v("공정도 바로가기")])]) : _vm._e()])])]), _c('ul', {
    staticClass: "protocol_writer_list",
    class: _vm.writerListActive ? 'on' : null
  }, _vm._l(_vm.collaborators, function (collaborator, collaboratorKey) {
    var _collaborator$company, _collaborator$belong, _collaborator$researc, _collaborator$email, _collaborator$mobile, _collaborator$researc2, _vm$enactmentDate;

    return _c('li', {
      key: collaboratorKey
    }, [_c('ul', {
      staticClass: "writer_info"
    }, [_c('li', {
      staticClass: "user_name"
    }, [_vm._m(0, true), _c('div', {
      staticClass: "name"
    }, [_c('strong', [_vm._v(_vm._s(collaborator.name))]), _c('span', [_vm._v(_vm._s(`${collaboratorKey == 0 ? "책임작성자" : "공동작성자"}`))])])]), _c('li', [_c('label', [_vm._v("기관")]), _c('p', [_vm._v(_vm._s(`${((_collaborator$company = collaborator.companyName) === null || _collaborator$company === void 0 ? void 0 : _collaborator$company.length) > 0 ? collaborator.companyName : "-"}`))])]), _c('li', [_c('label', [_vm._v("소속")]), _c('p', [_vm._v(_vm._s(`${((_collaborator$belong = collaborator.belong) === null || _collaborator$belong === void 0 ? void 0 : _collaborator$belong.length) > 0 ? collaborator.belong : "-"}`))])]), _c('li', [_c('label', [_vm._v("국가연구자번호")]), _c('p', [_vm._v(_vm._s(`${((_collaborator$researc = collaborator.researcherNumber) === null || _collaborator$researc === void 0 ? void 0 : _collaborator$researc.length) > 0 ? collaborator.researcherNumber : "-"}`))])]), _c('li', [_c('label', [_vm._v("이메일")]), _c('p', [_vm._v(_vm._s(`${((_collaborator$email = collaborator.email) === null || _collaborator$email === void 0 ? void 0 : _collaborator$email.length) > 0 ? collaborator.email : "-"}`))])]), _c('li', [_c('label', [_vm._v("전화번호")]), _c('p', [_vm._v(_vm._s(`${((_collaborator$mobile = collaborator.mobile) === null || _collaborator$mobile === void 0 ? void 0 : _collaborator$mobile.length) > 0 ? collaborator.mobile : "-"}`))])]), _c('li', [_c('label', [_vm._v("연구분야")]), _c('p', [_vm._v(_vm._s(`${((_collaborator$researc2 = collaborator.researcherPart) === null || _collaborator$researc2 === void 0 ? void 0 : _collaborator$researc2.length) > 0 ? collaborator.researcherPart : "-"}`))])]), _c('li', [_c('label', [_vm._v("제정일")]), _c('p', [_vm._v(_vm._s(`${((_vm$enactmentDate = _vm.enactmentDate) === null || _vm$enactmentDate === void 0 ? void 0 : _vm$enactmentDate.length) > 0 ? _vm.enactmentDate : "-"}`))])])])]);
  }), 0)]), _c('div', {
    staticClass: "view_body"
  }, [_c('div', {
    staticClass: "protocol_detailtop"
  }, [_c('ul', {
    staticClass: "protocol_detailtop_tab"
  }, [_c('li', {
    class: _vm.viewType == _vm.viewTepeList[0] ? 'on' : null,
    on: {
      "click": function ($event) {
        return _vm.tabSelect(0);
      }
    }
  }, [_c('a', {
    staticClass: "icon1",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("트리보기")])]), _c('li', {
    class: _vm.viewType == _vm.viewTepeList[1] ? 'on' : null,
    on: {
      "click": function ($event) {
        return _vm.tabSelect(1);
      }
    }
  }, [_c('a', {
    staticClass: "icon2",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("위키보기")])])]), _c('div', {
    staticClass: "protocol_detailtop_btn"
  }, [_vm.processType == 'NORMAL' ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.includedProtocolsActive = true;
      }
    }
  }, [_vm._v("포함된 프로토콜 보기")]) : _vm._e(), _vm.thisMyPage ? _c('button', {
    staticClass: "edit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('goToProtocolEditor');
      }
    }
  }, [_vm._v(" 수정하기 ")]) : _vm._e()])]), _c('div', {
    staticClass: "protocol_detail_cont"
  }, [_vm.viewType == _vm.viewTepeList[0] ? _c('newTreeViewer', {
    attrs: {
      "Data": _vm.treeViewData
    }
  }) : _vm.viewType == _vm.viewTepeList[1] ? _c('newWikiViewer', {
    attrs: {
      "Data": _vm.wikiViewData
    }
  }) : _vm._e()], 1)])]), _c('IncludedProtocols', {
    attrs: {
      "inProcessId": _vm.inProcessId,
      "lastEditDate": _vm.lastEditDate,
      "active": _vm.includedProtocolsActive,
      "publishingActive": _vm.publishingActive
    },
    on: {
      "goToDetail": _vm.goToDetail,
      "close": function ($event) {
        _vm.includedProtocolsActive = false;
      }
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ico"
  }, [_c('span', {
    staticClass: "icon_img"
  })]);

}]

export { render, staticRenderFns }